export const forgotPasswordPage = () =>
  import("./ForgotPasswordPage").then((m) => ({ Component: m.ForgotPasswordPage }));
